/* Sou Voe - Barra de progresso de beneficios (frete gratis + brinde)
   Niveis editaveis em NIVEIS. O brinde depende do desconto automatico
   "Brinde: Sabonete Facial Equilibrio (compras acima de R$169)" no Shopify. */
(function(){
  if (window.__svBarra) return; window.__svBarra = true;

  var NIVEIS = { frete: 129, brinde: 169 };
  var BRINDE = { variante: 43464082915577, nome: 'Sabonete Facial Equilíbrio' };

  var css = '' +
    '.sv-barra{background:#f3f6f4;border:1px solid #dfe7e2;border-radius:10px;padding:14px 16px 12px;font-size:14px;line-height:1.35;color:#222}' +
    '.sv-barra__msg{margin:0;text-align:center}' +
    '.sv-barra__msg b{color:#537a5e}' +
    '.sv-barra__sub{margin:4px 0 0;text-align:center;font-size:12px;color:#6b6b6b}' +
    '.sv-barra__track{position:relative;height:8px;background:#dfe7e2;border-radius:99px;margin:18px 14px 30px}' +
    '.sv-barra__fill{position:absolute;left:0;top:0;bottom:0;width:0;background:#537a5e;border-radius:99px;transition:width .6s ease}' +
    '.sv-barra__mk{position:absolute;top:50%;width:28px;height:28px;margin:-14px 0 0 -14px;border-radius:50%;background:#fff;border:2px solid #cfd9d3;display:flex;align-items:center;justify-content:center;color:#9aa8a0;transition:all .3s}' +
    '.sv-barra__mk.ok{background:#537a5e;border-color:#537a5e;color:#fff}' +
    '.sv-barra__mk svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.sv-barra__lb{position:absolute;top:34px;left:50%;transform:translateX(-50%);font-size:11px;white-space:nowrap;color:#6b6b6b}' +
    '.sv-barra__mk--fim .sv-barra__lb{left:auto;right:-6px;transform:none}' +
    '.sv-barra__btn{display:block;margin:2px auto 0;padding:9px 18px;border:0;border-radius:6px;background:#537a5e;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
    '.sv-barra__btn:disabled{opacity:.6;cursor:wait}' +
    '.sv-barra__ok{margin:2px 0 0;text-align:center;font-size:12px;color:#537a5e;font-weight:600}' +
    '.sv-barra-home{max-width:760px;margin:28px auto;padding:0 15px}' +
    '#Cart-Drawer .sv-barra{margin:0 0 14px;padding:12px 14px 6px}';
  var st = document.createElement('style'); st.id = 'sv-barra-css'; st.textContent = css; document.head.appendChild(st);

  var ICON_FRETE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>';
  var ICON_BRINDE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3-5-1s3 1 5 1zM12 7c1.5-3 5-3 5-1s-3 1-5 1z"/></svg>';

  function brl(v){ return (v/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); }
  function brl0(v){ return (v/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL',maximumFractionDigits:0}); }
  var cartCache = null;
  function getCart(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){ cartCache = c; return c; }); }

  function totalQualificado(c){
    var total = 0, giftLine = null;
    (c.items||[]).forEach(function(it){
      total += it.final_line_price;
      if (it.variant_id === BRINDE.variante) giftLine = it;
    });
    // o brinde (1 unidade) nao conta para atingir o valor minimo
    if (giftLine) total -= Math.round(giftLine.final_line_price / giftLine.quantity);
    return { total: Math.max(0,total), temBrinde: !!giftLine, brindeGratis: giftLine ? giftLine.final_line_price < giftLine.original_line_price : false };
  }

  function html(c){
    var q = totalQualificado(c), t = q.total;
    var F = NIVEIS.frete*100, B = NIVEIS.brinde*100;
    var pct = Math.min(100, t / B * 100);
    var msg, sub = '', extra = '';
    if (t < F) {
      msg = 'Faltam <b>' + brl(F - t) + '</b> para <b>FRETE GRÁTIS</b>';
      sub = 'e ' + brl(B - t) + ' para ganhar um ' + BRINDE.nome + ' de brinde';
    } else if (t < B) {
      msg = 'Você já tem <b>FRETE GRÁTIS</b>! Faltam <b>' + brl(B - t) + '</b> para ganhar um <b>' + BRINDE.nome + '</b> de brinde';
    }
    if (t < B && q.temBrinde && !q.brindeGratis) {
      sub = 'O ' + BRINDE.nome + ' do carrinho está sendo cobrado. Ele sai grátis a partir de ' + brl0(B) + ' em outros produtos.';
    }
    if (t >= B) {
      msg = 'Parabéns! Você ganhou <b>FRETE GRÁTIS + BRINDE</b>';
      if (!q.temBrinde) extra = '<button type="button" class="sv-barra__btn" data-sv-add-brinde>Adicionar meu brinde grátis</button>';
      else extra = '<p class="sv-barra__ok">✓ ' + BRINDE.nome + ' no carrinho, por R$ 0,00</p>';
    }
    if (!c.item_count) {
      msg = '<b>FRETE GRÁTIS</b> acima de ' + brl0(F) + ' + <b>BRINDE</b> acima de ' + brl0(B);
      sub = 'Ganhe um ' + BRINDE.nome + ' nas compras a partir de ' + brl(B);
    }
    var pF = F / B * 100;
    return '<p class="sv-barra__msg">' + msg + '</p>' + (sub ? '<p class="sv-barra__sub">' + sub + '</p>' : '') +
      '<div class="sv-barra__track" role="progressbar" aria-valuemin="0" aria-valuemax="' + (B/100) + '" aria-valuenow="' + Math.round(t/100) + '">' +
        '<div class="sv-barra__fill" style="width:' + pct.toFixed(1) + '%"></div>' +
        '<span class="sv-barra__mk' + (t >= F ? ' ok' : '') + '" style="left:' + pF.toFixed(1) + '%">' + ICON_FRETE + '<span class="sv-barra__lb">' + brl0(F) + '</span></span>' +
        '<span class="sv-barra__mk sv-barra__mk--fim' + (t >= B ? ' ok' : '') + '" style="left:100%">' + ICON_BRINDE + '<span class="sv-barra__lb">' + brl0(B) + '</span></span>' +
      '</div>' + extra;
  }

  function alvos(){
    var list = [].slice.call(document.querySelectorAll('[data-sv-barra]'));
    var inner = document.querySelector('#Cart-Drawer .side-panel-inner');
    var content = inner && inner.querySelector('.side-panel-content');
    if (content && !content.querySelector('.cart-drawer__empty-cart')) {
      var el = content.querySelector(':scope > .sv-barra');
      if (!el) { el = document.createElement('div'); el.className = 'sv-barra'; content.insertBefore(el, content.firstChild); }
      list.push(el);
    }
    return list;
  }

  var rendering = false;
  function render(cart){
    var els = alvos(); if (!els.length) return;
    var go = function(c){ rendering = true; els.forEach(function(el){ if (!el.classList.contains('sv-barra')) el.classList.add('sv-barra'); el.innerHTML = html(c); }); setTimeout(function(){ rendering = false; }, 50); };
    if (cart) go(cart); else getCart().then(go).catch(function(){});
  }

  function atualizarDrawer(){
    return fetch('/?sections=cart-drawer').then(function(r){return r.json();}).then(function(s){
      var h = s && s['cart-drawer']; if (!h) return;
      var tmp = document.createElement('div'); tmp.innerHTML = h;
      var novo = tmp.querySelector('.side-panel-inner'), atual = document.querySelector('#Cart-Drawer .side-panel-inner');
      if (novo && atual) atual.innerHTML = novo.innerHTML;
    }).catch(function(){});
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-sv-add-brinde]'); if (!b) return;
    e.preventDefault(); b.disabled = true; b.textContent = 'Adicionando...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:BRINDE.variante,quantity:1}]})})
      .then(function(){ return atualizarDrawer(); })
      .then(function(){ render(); })
      .catch(function(){ b.disabled = false; b.textContent = 'Adicionar meu brinde grátis'; });
  });

  // atualiza quando o carrinho muda (qualquer chamada /cart/*)
  var _fetch = window.fetch;
  window.fetch = function(input){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function(){ setTimeout(function(){ render(); }, 300); }).catch(function(){});
    return p;
  };

  function init(){ render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  var tm; new MutationObserver(function(){
    if (rendering) return;
    var inner = document.querySelector('#Cart-Drawer .side-panel-inner');
    var content = inner && inner.querySelector('.side-panel-content');
    if (content && !content.querySelector(':scope > .sv-barra') && !content.querySelector('.cart-drawer__empty-cart')) { clearTimeout(tm); tm = setTimeout(function(){ render(); }, 150); }
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
